import { Table, TableBody, TableCell, TableFooter, TableRow } from "@material-ui/core";
import { calculateQuarterly, calculateYearly, formatMoneyCents } from "../../helpers";
import { BlackCellBorderWhite, BrightYellowCellBorder, LightYellowCellBorder, StyledTableRow } from "../Page/TableStyles";

export function MinMaxTable(props) {
    const {formData, dailyProduction} = props;


    return (
        <Table size='small'>
            <TableBody>
                <StyledTableRow>
                    <BrightYellowCellBorder colSpan={2}>Minimum & Maximum Returns</BrightYellowCellBorder>
                </StyledTableRow>
                <StyledTableRow>
                    <BrightYellowCellBorder></BrightYellowCellBorder>
                    <BrightYellowCellBorder>Quarter</BrightYellowCellBorder>
                    <BrightYellowCellBorder>Annual</BrightYellowCellBorder>
                    <BrightYellowCellBorder>5 Year</BrightYellowCellBorder>
                    <BrightYellowCellBorder>10 Year</BrightYellowCellBorder>
                    <BrightYellowCellBorder>25 Year</BrightYellowCellBorder>
                </StyledTableRow>
                <StyledTableRow>
                    <BlackCellBorderWhite>Maximum Savings</BlackCellBorderWhite>
                    <TableCell>{formatMoneyCents(calculateQuarterly(formData.powerPrice * dailyProduction))}</TableCell>
                    <TableCell>{formatMoneyCents(calculateYearly(formData.powerPrice * dailyProduction))}</TableCell>
                    <TableCell>{formatMoneyCents(calculateYearly(formData.powerPrice * dailyProduction) * 5)}</TableCell>
                    <TableCell>{formatMoneyCents(calculateYearly(formData.powerPrice * dailyProduction) * 10)}</TableCell>
                    <TableCell>{formatMoneyCents(calculateYearly(formData.powerPrice * dailyProduction) * 25)}</TableCell>
                </StyledTableRow>
                <StyledTableRow>
                    <BrightYellowCellBorder>Minimum Savings</BrightYellowCellBorder>
                    <LightYellowCellBorder>{formatMoneyCents(calculateQuarterly(dailyProduction * formData.feedInTariff))}</LightYellowCellBorder>
                    <LightYellowCellBorder>{formatMoneyCents(calculateYearly(dailyProduction * formData.feedInTariff))}</LightYellowCellBorder>
                    <LightYellowCellBorder>{formatMoneyCents(calculateYearly(dailyProduction * formData.feedInTariff) * 5)}</LightYellowCellBorder>
                    <LightYellowCellBorder>{formatMoneyCents(calculateYearly(dailyProduction * formData.feedInTariff) * 10)}</LightYellowCellBorder>
                    <LightYellowCellBorder>{formatMoneyCents(calculateYearly(dailyProduction * formData.feedInTariff) * 25)}</LightYellowCellBorder>
                </StyledTableRow>
            </TableBody>
            <TableFooter>
                <TableRow>
                    <TableCell colSpan={6}>
                        The above summarises 2 extremes, the best case scenario, where you use all of the power generated, and
                        the worst case scenario where you sell every kWH produced to your energy provider, the most accurate
                        answer is somewhere in the middle, below we will give our best estimate based on having installed over
                        15000 solar system and your valuable input.
                    </TableCell>
                </TableRow>
            </TableFooter>
        </Table>
    )
}